import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';


function Service1() {
  return (
    <div className="container">


      <div className="section-heading text-center mb-40">

        <h2 className="text-anim" data-effect="fade-in-right" data-split="char" data-delay="0.3" data-duration={1}><span className="hl">IT Solutions</span></h2>
        <p className="text-anim" data-effect="fade-in-bottom" data-ease="power4.out">Empowering businesses with advanced technology solutions and exceptional support.<br />to enhance your business operations.</p>
      </div>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={20}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        breakpoints={{
          0: { slidesPerView: 1, spaceBetween: 10 }, // Force 1 slide on mobile
          640: { slidesPerView: 1, spaceBetween: 10 }, // Mobile (up to 640px)
          768: { slidesPerView: 2, spaceBetween: 15 }, // Tablets
          1024: { slidesPerView: 3, spaceBetween: 20 }, // Desktops
        }}
        className="pb-10"
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <div className="project-item">
            <Link to="/project">
              <div className="project-thumb">
                <img src="assets/img/itproject.jpg" alt="IT Projects" className="w-full h-auto" />
              </div>
            </Link>
            <div className="project-content">
              <Link to="/project" className="category">IT Projects</Link>
              <h3>
                At <span className="font-bold text-gray-900">TITA Technologies</span>, every challenge is an opportunity to innovate.
              </h3>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 2 */}
        <SwiperSlide>
          <div className="project-item">
            <Link to="/staffing">
              <div className="project-thumb">
                <img src="assets/img/staffing.jpg" alt="IT Staffing" className="w-full h-auto" />
              </div>
            </Link>
            <div className="project-content">
              <Link to="/staffing" className="category">IT Staffing & Contracting</Link>
              <h3>Connect with top IT talent through our expert staffing solutions.</h3>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 3 */}
        <SwiperSlide>
          <div className="project-item">
            <Link to="/training">
              <div className="project-thumb">
                <img src="assets/img/it trainning.jpg" alt="IT Training" className="w-full h-auto" />
              </div>
            </Link>
            <div className="project-content">
              <Link to="/training" className="category">IT Training & Upskills</Link>
              <h3>Empower individuals and teams with hands-on learning in React.js, Data Science, and Cybersecurity.</h3>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 4 */}
        <SwiperSlide>
          <div className="project-item">
            <div className="project-thumb">
              <img src="assets/img/career.jpg" alt="IT Career Counseling" className="w-full h-auto" />
            </div>
            <div className="project-content">
              <Link to="/careers" className="category">IT Career Counseling</Link>
              <h3>Empowering your career with personalized guidance and support.</h3>
            </div>
          </div>
        </SwiperSlide>

        {/* Slide 5 */}
        <SwiperSlide>
          <div className="project-item">
            <Link to="/infrastructure">
              <div className="project-thumb">
                <img src="assets/img/itinfa.jpg" alt="IT Infrastructure" className="w-full h-auto" />
              </div>
            </Link>
            <div className="project-content">
              <Link to="/infrastructure" className="category">IT Infrastructure</Link>
              <h3>Building and maintaining robust IT infrastructure for businesses.</h3>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default Service1;
